export function toggle() {
	var toggleButtons = document.querySelectorAll('.js-toggle-contact');
	var formDiv = document.querySelector('#toggleContact');
	for (var i = 0; i < toggleButtons.length; i++) {
		toggleButtons[i].addEventListener('click', function() {
			formDiv.classList.toggle('show');
		});
	}
}